import { render, staticRenderFns } from "./ExpertDataChangeRecord.vue?vue&type=template&id=05b254c2"
import script from "./ExpertDataChangeRecord.vue?vue&type=script&lang=js"
export * from "./ExpertDataChangeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports